import { render, staticRenderFns } from "./LeadClosingReasonModal.vue?vue&type=template&id=4a2b307d&scoped=true&"
import script from "./LeadClosingReasonModal.vue?vue&type=script&lang=js&"
export * from "./LeadClosingReasonModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2b307d",
  null
  
)

export default component.exports